import { Card, CardContent, CardFooter, Timeline } from '@ps/isp-web-component-library';
import React from 'react';

import { MultipleSelections } from '@swf/sports/components/Selection/MultipleSelections';
import { useNormalisedEventBasedData } from '@swf/sports/hooks/useNormalisedEventBasedData';

import type { PopularBetBuilder } from '../../types';
import PopularBetBuilderItem from '../PopularBetBuilderItem/PopularBetBuilderItem';

import EventDetailsHeader from './components/EventDetailsHeader/EventDetailsHeader';

interface Props {
  popularBetBuilder: PopularBetBuilder;
}

const PopularBetBuilderCard: React.FC<Props> = ({ popularBetBuilder }: Props) => {
  const { markets } = useNormalisedEventBasedData({
    eventId: popularBetBuilder.eventId
  });

  return (
    <Card>
      <EventDetailsHeader
        eventId={popularBetBuilder.eventId}
        popularBetBuilderCount={popularBetBuilder.count}
      />
      <CardContent>
        <Timeline>
          {popularBetBuilder.runnersIds.map((runnerId) => (
            <PopularBetBuilderItem
              key={`${runnerId.marketId}-${runnerId.selectionId}`}
              {...runnerId}
            />
          ))}
        </Timeline>
      </CardContent>
      <CardFooter>
        <MultipleSelections
          selections={popularBetBuilder.runnersIds.map((runnerId) => ({
            runnerId,
            market: markets[runnerId.marketId]
          }))}
          odds={popularBetBuilder.winRunnerOdds}
        />
      </CardFooter>
    </Card>
  );
};

export default PopularBetBuilderCard;
